import { render, staticRenderFns } from "./CIBNSetting.vue?vue&type=template&id=94930918&scoped=true"
import script from "./CIBNSetting.vue?vue&type=script&lang=js"
export * from "./CIBNSetting.vue?vue&type=script&lang=js"
import style0 from "./CIBNSetting.vue?vue&type=style&index=0&id=94930918&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94930918",
  null
  
)

export default component.exports